export function getAppointmentGroupKey(item) {
  const leadId = String(item?.lead_id ?? item?.leadId ?? "").trim();
  const propertyId = String(item?.property_id ?? "").trim();
  if (leadId && propertyId) {
    return `${leadId}_${propertyId}`;
  }
  return String(item?._id ?? "");
}

export function groupAppointmentRows(rows = []) {
  const groups = new Map();

  rows.forEach((item) => {
    const key = getAppointmentGroupKey(item);
    if (!groups.has(key)) {
      groups.set(key, []);
    }
    groups.get(key).push(item);
  });

  return Array.from(groups.entries()).map(([key, items]) => {
    const sorted = [...items].sort((a, b) => {
      const ta = a?.createdDate ? new Date(a.createdDate).getTime() : 0;
      const tb = b?.createdDate ? new Date(b.createdDate).getTime() : 0;
      if (tb !== ta) return tb - ta;
      const da = a?.appointment_date
        ? new Date(a.appointment_date).getTime()
        : 0;
      const db = b?.appointment_date
        ? new Date(b.appointment_date).getTime()
        : 0;
      if (db !== da) return db - da;
      return String(b?._id || "").localeCompare(String(a?._id || ""));
    });

    return {
      key,
      primary: sorted[0],
      others: sorted.slice(1),
    };
  });
}
